import cloneDeep from 'lodash/fp/cloneDeep'
import {
  ADMINISTRATOR_RESETTING_PASSWORD,
  ADMINISTRATOR_PASSWORD_RESET,
  ADMINISTRATOR_SET_EMAIL_ADDRESS
} from './administrationResetPasswordContainerActions.js'
import { validiateEmailField } from '../../common/forms/validationFunctions'

const initialState = {
  submitting: false,
  submitted: false,
  emailAddress: '',
  emailAddressEdited: false,
  isInvalid: {
    formIsValid: false,
    emailAddress: {
      isInvalid: false,
      message: null
    }
  }
}

export default function (state = initialState, action) {
  var newState = cloneDeep(state)
  switch (action.type) {
    case ADMINISTRATOR_SET_EMAIL_ADDRESS:
      newState.emailAddress = action.emailAddress
      newState.emailAddressEdited = true
      newState.isInvalid.emailAddress = validiateEmailField(action.emailAddress, true)
      newState.isInvalid.formIsValid = formIsValid(newState)
      return newState
    case ADMINISTRATOR_PASSWORD_RESET:
      newState.submitting = false
      newState.submitted = true
      return newState
    case ADMINISTRATOR_RESETTING_PASSWORD:
      newState.submitting = true
      newState.submitted = false
      return newState

  }
  return state
}

function formIsValid (state) {
  return state.emailAddressEdited &&
      state.isInvalid.emailAddress.isInvalid !== true
}
